import axios from "axios";
import { appConfigs } from "../../../../../_yp_db/_helpers";

// CREATE =>  POST: add a new professional to the server
export function createProfessional(professional) {
  return axios.post(appConfigs.api_url + 'professionals/create', { professional });
}

// READ
export function getAllProfessionals() {
  return axios.post(appConfigs.api_url + 'professionals');
}

export function getProfessionalById(professionalId) {
  return axios.post(`${appConfigs.api_url}professionals/get`, { id: professionalId })
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findProfessionals(queryParams) {
  return axios.post(`${appConfigs.api_url}professionals`, { queryParams });
}

// UPDATE => POST: update the professional on the server
export function updateProfessional(professional) {
  return axios.post(`${appConfigs.api_url}professionals/update`, { professional });
}

// UPDATE Status
export function updateStatusForProfessionals(ids, status) {
  return axios.post(`${appConfigs.api_url}/updateStatusForProfessionals`, {
    ids,
    status
  });
}

// DELETE => delete the professional from the server
export function deleteProfessional(professionalId) {
  return axios.post(`${appConfigs.api_url}professionals/delete`, { id: professionalId });
}

// DELETE Professionals by ids
export function deleteProfessionals(ids) {
  return axios.post(`${appConfigs.api_url}professionals/delete-professionals`, { professional_ids: ids });
}


//check phone
export function checkPhone(phone) {
  return axios.post(`${appConfigs.api_url}professionals/check-phone`, { phone });
}

//import excel
export function importExcel(file) {
  return axios.post(`${appConfigs.api_url}professionals/import-excel`, { file });
}


//importExcelNonMembers
export function importExcelNonMembers(file) {
  return axios.post(`${appConfigs.api_url}professionals/import-excel-non-members`, { file });
}
